import { isEmpty, isNil } from "lodash";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PrimaryContentCard from "../../../../../_src_shared/components/layout/PrimaryContentCard";
import InsetCard from "../../../../../components/ui/InsetCard";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import {
  sidebarSetParamsValue,
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../../../redux/actions/sidebarActions";
import LoanDrilldownButtonAddBrokerTerm from "../../../buttons/LoanDrilldownButtonAddBrokerTerm";
import OriginatorFeesTable from "../tables/OriginatorFeesTable";

const LoanFeesSubTabBrokerTerms = () => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const dispatch = useDispatch();

  const brokerTerms = useMemo(
    () => loanTerms?.brokerTerms || [],
    [loanTerms?.brokerTerms]
  );
  const headerSubtitle = useMemo(() => {
    if (isEmpty(brokerTerms)) {
      return "Add and manage broker terms associated with this loan.";
    }
    return "Click any of the following rows to edit a broker term";
  }, [loanDrilldown, brokerTerms]);

  const onRowClicked = useCallback((d) => {
    dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_EDIT_BROKER_TERMS));
    dispatch(sidebarSetParamsValue(null));
    dispatch(sidebarSetStateValue(d));
  }, []);

  return (
    <PrimaryContentCard
      maxWidth="lg"
      title="Broker Terms"
      subTitle={headerSubtitle}
      endContent={<LoanDrilldownButtonAddBrokerTerm />}
      loading={isNil(loanTerms)}
    >
      <InsetCard sx={{ p: 0, overflow: "hidden" }}>
        <OriginatorFeesTable
          rowData={brokerTerms}
          onRowClicked={onRowClicked}
        />
      </InsetCard>
    </PrimaryContentCard>
  );
};

/**
 * COMPONENTS
 */

export default LoanFeesSubTabBrokerTerms;
